import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button as AntdButton, Flex, Form, InputNumber, message, Input, Select, Button, List, Typography, } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../../../components/common/Icon';
import { createMap3DObjectPropertyAction, getMap3DObjectPropertiesAction, deleteMap3DObjectPropertyAction, updateMap3DObjectPropertyAction } from '../../../../../store/mapObjectSlice';
import { InnerFormSection, LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../../../editor.style';
const initialValues = {
    name: null,
    nodeId: null,
    mapObjectId: undefined,
    scale: 0,
    rotation: 0,
    altitude: 0,
    light: 0,
};
const MapThreeDObjectFormPanel = ({ data, siteId, isOpen, onBack, activateSelectTool, mapObjectForm }) => {
    const dispatch = useDispatch();
    const form = mapObjectForm;
    const [container, setContainer] = useState(null);
    const [editData, setEditData] = useState(false);
    const map3DObjects = useSelector((state) => state?.mapObject?.getMapObjects?.response?.content);
    const mapNodeId = Form.useWatch('nodeId', form);
    useEffect(() => {
        if (data) {
            form.setFieldsValue(data);
            setEditData(data);
        }
        else {
            form.setFieldsValue(initialValues);
            setEditData(false);
        }
    }, [data]);
    const creating = false;
    const onSave = (values) => {
        try {
            if (siteId) {
                if (data) {
                    //@ts-ignore
                    dispatch(updateMap3DObjectPropertyAction({ siteId: siteId, mapObjectPropertyId: data?.id, data: { ...values, siteId } })).then(() => {
                        dispatch(getMap3DObjectPropertiesAction(siteId));
                        message.success('3D properties updated succesfully');
                        form.resetFields();
                        onBack();
                    });
                }
                else {
                    dispatch(createMap3DObjectPropertyAction({ ...values, siteId })).then(() => {
                        dispatch(getMap3DObjectPropertiesAction(siteId));
                        message.success('3D properties added successfully');
                        form.resetFields();
                        onBack();
                    });
                }
            }
        }
        catch (error) {
            message.error('Something went wrong');
        }
    };
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { isOpen: isOpen, style: {
                width: '340px',
            }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                            onBack();
                                        } }), _jsx("h3", { children: 'Create New 3D Object Mapping' })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsxs(Form
                            //@ts-ignore
                            , {
                                //@ts-ignore
                                initialValues: editData || initialValues, form: form, layout: "vertical", onFinish: async (values) => {
                                    onSave(values);
                                }, children: [_jsx(Form.Item, { name: "name", label: "Name", required: true, tooltip: "This is a required field", rules: [{ required: true, message: 'Name is required' }], children: _jsx(Input, { placeholder: "Property name", variant: "filled" }) }), _jsx(Form.Item, { required: true, label: "Connect Nodes", rules: [{ required: true, message: 'Node Id is required' }], tooltip: "This is a required field", children: _jsxs(InnerFormSection, { children: [_jsx(Form.Item, { name: "nodeId", rules: [{ required: true, message: 'Node is required' }], style: { display: 'none' }, children: _jsx(Input, { size: "small", disabled: true }) }), form.getFieldValue('nodeId') && (_jsx(List, { children: _jsx(List.Item, { children: _jsx(List.Item.Meta, { title: _jsx(Flex, { vertical: true, children: form.getFieldValue('nodeId') && (_jsxs(Flex, { vertical: true, children: [_jsx(Typography.Text, { children: "Node Id:" }), _jsx(Typography.Text, { type: "secondary", children: form.getFieldValue('nodeId') })] })) }), description: "" }) }) })), _jsx(AntdButton, { variant: "dashed", color: "default", block: true, icon: _jsx(Icon, { icon: "link-03", size: 15 }), iconPosition: "end", onClick: () => {
                                                        activateSelectTool();
                                                    }, children: `${mapNodeId ? 'Edit' : 'Connect'} Node` })] }) }), _jsx(Form.Item, { name: "mapObjectId", label: "3D Object", required: true, tooltip: "This is a required field", rules: [{ required: true }], children: _jsx(Select, { variant: "filled", allowClear: true, placeholder: "3D Object Name", options: (map3DObjects || []).map((it) => ({
                                                label: it.name,
                                                value: it.id,
                                            })) }) }), _jsx(Form.Item, { required: true, label: "Scale", tooltip: "Enter the scale value", name: "scale", children: _jsx(InputNumber, { placeholder: "Enter scale", variant: "filled", style: { width: '100%' } }) }), _jsx(Form.Item, { required: true, label: "Rotate", tooltip: "Enter the rotation value", name: "rotation", children: _jsx(InputNumber, { placeholder: "Enter rotation", variant: "filled", style: { width: '100%' } }) }), _jsx(Form.Item, { required: true, label: "Altitude", tooltip: "Enter the altitude value", name: "altitude", children: _jsx(InputNumber, { placeholder: "Enter altitude", variant: "filled", style: { width: '100%' } }) }), _jsx(Form.Item, { required: true, label: "Light", tooltip: "Enter the light intensity value", name: "light", children: _jsx(InputNumber, { placeholder: "Enter light intensity", variant: "filled", style: { width: '100%' } }) })]
                            }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { onClick: () => {
                                        if (data) {
                                            try {
                                                dispatch(deleteMap3DObjectPropertyAction({ siteId: siteId, mapObjectPropertyId: data.id })).then(() => {
                                                    dispatch(getMap3DObjectPropertiesAction(siteId));
                                                    message.success('Property deleted succesfully');
                                                    onBack();
                                                });
                                            }
                                            catch {
                                                message.error('Something went wrong');
                                            }
                                        }
                                        else {
                                            onBack();
                                        }
                                    }, color: "danger", variant: "filled", children: data ? 'Delete' : 'Cancel' }), _jsx(Button, { loading: creating, onClick: () => {
                                        form.submit();
                                    }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }) }));
};
export default React.memo(MapThreeDObjectFormPanel);
